import { CharacterAttack } from './CharacterAttack';

export class AttackRavenSpecialStanding extends CharacterAttack {
  trigger() {
    super.trigger();

    this.attackCollider.width = 0;
    this.attackCollider.height = 300;
    this.attackCollider.y = this.character.y - 300;
    this.scene.tweens.add({
      targets: this.attackCollider,
      x: this.character.x + (this.character.faceDirection > 0 ? 0 : -350),
      width: 350,
      duration: 250,
      yoyo: true,
      hold: 500,
    });
  }

  updateAttackCollider() {}
}
